export default "__VITE_ASSET__BpABpJc8__"